import { useContext } from 'react'

import { UserProfileContext } from '../../User.contexts'

export function useUserProfileContext() {
  return useContext(UserProfileContext)
}
